<template>
  <div class="login_R_Form">
    <div class="login_R_FormItem flex_must">
      <div class="flex_must_1">文件上传</div>
      必填&nbsp;<a-switch size="small" v-model="checkData.options.require" />
    </div>
    <div class="login_R_FormItem">
      <div class="R_FormItem_name">组件名称</div>
      <div class="R_FormItem_data">
        <a-input @change='giveF' v-model="checkData.options.label" placeholder="请输入" :maxLength='20'
          :suffix="checkData.options.label ? checkData.options.label.length + '/20' : '0/20'" />
      </div>
    </div>
    <div class="login_R_FormItem">
      <p class="R_FormItem_name">文件类型</p>
      <!-- <a-radio-group v-model="checkData.options.fileType">
        <a-radio :value="'1'">
          无限制
        </a-radio>
        <a-radio :value="'2'">
          图片
        </a-radio>
        <a-radio :value="'3'">
          视频
        </a-radio>
        <a-radio :value="'4'">
          PDF/word
        </a-radio>
        <a-radio :value="'5'">
          Excel
        </a-radio>
      </a-radio-group> -->

      <a-checkbox-group @change='giveF' v-model="checkData.options.fileType">
        <a-checkbox :value="'typeA'">
          无限制
        </a-checkbox>
        <a-checkbox :value="'typeB'">
          图片
        </a-checkbox>
        <a-checkbox :value="'typeC'">
          视频
        </a-checkbox>
        <a-checkbox :value="'typeD'">
          Word
        </a-checkbox>
        <a-checkbox :value="'typeE'">
          Excel
        </a-checkbox>
        <a-checkbox :value="'typeF'">
          PDF
        </a-checkbox>
      </a-checkbox-group>
    </div>

    <div class="login_R_FormItem">
      <p class="R_FormItem_name">文件大小</p>
      <a-input @change='giveF' v-model="checkData.options.fileNumber" type='number' placeholder="请输入" suffix="m" />
    </div>

    <div class="login_R_FormItem">
      <p class="R_FormItem_name">文件数量</p>
      <a-input @change='giveF' v-model="checkData.options.fileSize" type='number' placeholder="请输入" suffix="个" />
    </div>

    <!-- 视频限制：勾选了“视频”类型后显示 -->
    <template v-if="checkData.options.fileType && checkData.options.fileType.indexOf('typeC') > -1">
      <div class="login_R_FormItem videoLimit_title">
        <p class="R_FormItem_name">视频限制</p>
      </div>
      <div class="login_R_FormItem">
        <p class="R_FormItem_name">视频最小时长</p>
        <a-input @change='giveF' v-model="checkData.options.video_min_time" type='number' min="0" placeholder="请输入" suffix="秒" />
      </div>
      <div class="login_R_FormItem">
        <p class="R_FormItem_name">视频最大时长</p>
        <a-input @change='giveF' v-model="checkData.options.video_max_time" type='number' min="0" placeholder="请输入" suffix="秒" />
      </div>
      <div class="login_R_FormItem">
        <p class="R_FormItem_name">视频长宽比</p>
        <a-select @change='giveF' style="width:100%" v-model="checkData.options.video_ratio">
          <a-select-option v-for="item in ratioList" :value="item.value" :key="item.value">{{ item.label }}
          </a-select-option>
        </a-select>
      </div>
    </template>

  </div>
</template>
<script> 
export default {
  props: ['checkData'], 
  data() {
    return {
      form: {},
      keyValue: 0,
      ratioList: [
        { label: '不限制', value: '' },
        { label: '16:9', value: '16:9' },
        { label: '4:3', value: '4:3' },
        { label: '3:4', value: '3:4' },
        { label: '9:16', value: '9:16' },
        { label: '1:1', value: '1:1' }
      ]
    };
  }, 
  methods: {
    giveF() {
      console.log(23456789)
      this.$emit('giveF')
    }
  },
  watch: {
    // 未勾选“视频”时，清理已配置的视频限制，避免残留到用户端
    'checkData.options.fileType': {
      handler(fileType) {
        if (!fileType || fileType.indexOf('typeC') === -1) {
          this.checkData.options.video_min_time = '';
          this.checkData.options.video_max_time = '';
          this.checkData.options.video_ratio = '';
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.login_R_Form {
  margin: 10px 24px;
  border-top: 1px solid #eff0f2;
  padding-top: 20px;

  .login_R_FormItem {
    margin-bottom: 20px;
  }

  .R_FormItem_name {
    font-weight: 500;
    font-size: 12px;
    color: #222222;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    margin-bottom: 12px;
  }
}

.flex_must {
  font-size: 14px;
  color: #222222;
  display: flex;
  align-items: center;

  .R_FormItem_name {
    flex: 1;
  }
}

.flex_must_1 {
  flex: 1;
}

.ant-radio-wrapper {
  margin-right: 0;
}
</style>
<style>
.login_R_FormItem .ant-radio-wrapper {
  margin-right: 12px;
  margin-bottom: 5px;
}

.login_R_FormItem .ant-checkbox-wrapper {
  margin-right: 12px;
  margin-bottom: 5px;
  margin-left: 0;
}
</style>